// Load the existing Reputon carousel only as the review section approaches.
let reviewScript;

class WheelerDeferredReviews extends HTMLElement {
  #observer;

  connectedCallback() {
    if (this.dataset.requested === 'true') return;
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      this.#load();
      return;
    }
    this.#observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#load();
    }, { rootMargin: '600px 0px' });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #load() {
    this.#observer?.disconnect();
    if (this.dataset.requested === 'true') return;
    this.dataset.requested = 'true';
    if (!reviewScript) {
      const source = this.dataset.scriptUrl;
      reviewScript = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      });
    }
    reviewScript.catch(() => {
      // The permanent Google link remains available if the vendor cannot load.
      this.dataset.loadFailed = 'true';
    });
  }
}

if (!customElements.get('wd-deferred-reviews')) {
  customElements.define('wd-deferred-reviews', WheelerDeferredReviews);
}
